import getThreadContentItemByThreadId from '@/lib/threads/getThreadContentItemByThreadId.js';
import getThreadsById from '@/lib/threads/getThreadsById.js';
import upsertSortedThread from '@/lib/threads/upsertSortedThread.js';

const applyThreadComposerMutation = ({ state, threadId, composerModel, composerReasoningEffort, updatedAt }) => {
  if (!threadId) {
    return state;
  }

  const existingMeta = getThreadsById(state.threads)?.[threadId];
  const existingContent = getThreadContentItemByThreadId(state.threadContent, threadId);

  if (!existingMeta || !existingContent) {
    return state;
  }

  const nextThreadMeta = {
    ...existingMeta,
    composerModel: composerModel || existingMeta?.composerModel,
    composerReasoningEffort: composerReasoningEffort || existingMeta?.composerReasoningEffort,
    updatedAt: updatedAt || existingMeta.updatedAt || new Date().toISOString()
  };

  return {
    ...state,
    threads: upsertSortedThread(state.threads, nextThreadMeta)
  };
};

export default applyThreadComposerMutation;
